/* global google */

export default {
  doClass () {
    USGSOverlay.prototype = new google.maps.OverlayView()

    function USGSOverlay (bounds, image, map) {
      // Now initialize all properties.
      this.bounds_ = bounds
      this.image_ = image
      this.img_ = null
      this.map_ = map

      // Define a property to hold the image's div. We'll
      // actually create this div upon receipt of the onAdd()
      // method so we'll leave it null for now.
      this.div_ = null

      // The canvas will be used to get pixel value at mouse
      // position
      this.canvas_ = null

      // For faster search, we memorize colors as 24-bit integers
      this.colorScale = [
        [245, 245, 0],
        [245, 216, 0],
        [245, 188, 0],
        [245, 163, 0],
        [245, 135, 0],
        [245, 106, 0],
        [245, 82, 0],
        [245, 53, 0],
        [245, 24, 0],
        [245, 0, 0]
      ]

      // Explicitly call setMap on this overlay
      this.setMap(map)

      // Cache to improve calculations
      this.cacheOffsetX = 0
      this.cacheOffsetY = 0
    }

    /**
     * onAdd is called when the map's panes are ready and the overlay has been
     * added to the map.
     */
    USGSOverlay.prototype.onAdd = function () {
      var self = this

      let div = document.createElement('div')
      div.style.border = 'none'
      div.style.borderWidth = '0px'
      div.style.position = 'absolute'
      div.style.visibility = 'hidden'

      // Create the img element and attach it to the div.
      let img = document.createElement('img')
      img.src = this.image_
      img.style.opacity = 1
      img.style.width = '100%'
      img.style.height = '100%'
      img.onload = function () { self.updateCanvas() }
      div.appendChild(img)

      this.img_ = img
      this.div_ = div

      // Add the element to the "overlayImage" pane.
      let panes = this.getPanes()
      panes.overlayLayer.appendChild(this.div_)

      // Create an offscreen canvas
      this.canvas_ = document.createElement('canvas')
    }

    USGSOverlay.prototype.draw = function () {
      // We use the south-west and north-east
      // coordinates of the overlay to peg it to the correct position and size.
      // To do this, we need to retrieve the projection from the overlay.
      var overlayProjection = this.getProjection()

      // Retrieve the south-west and north-east coordinates of this overlay
      // in LatLngs and convert them to pixel coordinates.
      // We'll use these coordinates to resize the div.
      var sw = overlayProjection.fromLatLngToDivPixel(this.bounds_.getSouthWest())
      var ne = overlayProjection.fromLatLngToDivPixel(this.bounds_.getNorthEast())

      // Cache
      this.cacheOffsetX = sw.x
      this.cacheOffsetY = ne.y

      // Resize the image's div to fit the indicated dimensions.
      var div = this.div_
      div.style.left = sw.x + 'px'
      div.style.top = ne.y + 'px'
      div.style.width = (ne.x - sw.x) + 'px'
      div.style.height = (sw.y - ne.y) + 'px'
      div.style.opacity = 0.75
    }

    USGSOverlay.prototype.getColorAt = function (event) {
      let pixel = this.getProjection().fromLatLngToDivPixel(event.latLng)
      let xx = Math.abs(Math.ceil(this.cacheOffsetX - pixel.x))
      let yy = Math.abs(Math.ceil(this.cacheOffsetY - pixel.y))
      let data = this.canvas_.getContext('2d').getImageData(xx, yy, 1, 1).data
      let len = this.colorScale.length
      for (let i = 0; i < len; i++) {
        if (Math.abs(data[0] - this.colorScale[i][0]) <= 4 &&
          Math.abs(data[1] - this.colorScale[i][1]) <= 4 &&
          Math.abs(data[2] - this.colorScale[i][2]) <= 4) {
          return i
        }
      }
      return -1
    }

    USGSOverlay.prototype.hide = function () {
      if (this.div_) {
        this.div_.style.visibility = 'hidden'
      }
    }

    USGSOverlay.prototype.show = function () {
      if (this.div_) {
        this.div_.style.visibility = 'visible'
      }
    }

    USGSOverlay.prototype.setImageUrl = function (url) {
      if (this.img_) {
        // Note that this will trigger img.onload event handler
        this.img_.src = url
      }
    }

    USGSOverlay.prototype.updateCanvas = function () {
      let w = this.img_.width
      let h = this.img_.height
      this.canvas_.width = w
      this.canvas_.height = h
      this.canvas_.getContext('2d').drawImage(this.img_, 0, 0, w, h)
    }

    return USGSOverlay
  }
}



// WEBPACK FOOTER //
// ./src/classes/USGSOverlay.js